import { render } from "./FAQs.vue?vue&type=template&id=a7941cd4&scoped=true"
import script from "./FAQs.vue?vue&type=script&lang=js"
export * from "./FAQs.vue?vue&type=script&lang=js"

import "./FAQs.vue?vue&type=style&index=0&id=a7941cd4&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7941cd4"]])

export default __exports__